var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmExCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#D3D3D3",
    fill: "#3498D8",
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 23,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.048 12.3h1.719l-.86-2-.859 2zM32 8.5h-4.404l-1.074 1.1-.966-1.1H16.21l-.86 1.8-.858-1.8h-3.76v.8l-.43-.8H7.082l-3.114 7h3.759l.43-1.1H9.23l.43 1.1h4.188v-.8l.322.8h2.149l.322-.9v.9h8.592l1.074-1.1.967 1.1h4.404L28.885 12 32 8.5zm-12.996 6h-1.182v-3.9l-1.826 3.9h-1.074l-1.826-3.9v3.9h-2.47l-.43-1.1H7.62l-.43 1.1H5.793l2.255-5h1.826l2.04 4.7V9.5h2.042l1.61 3.4 1.504-3.4h2.041v5h-.107zm10.633 0h-1.611l-1.396-1.7-1.611 1.7h-4.834v-5h4.94l1.505 1.6 1.61-1.6h1.504L27.381 12l2.256 2.5zm-8.27-4v.9h2.685v1h-2.685v1h3.007l1.396-1.5-1.289-1.4h-3.114z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmExCard);
export default __webpack_public_path__ + "static/media/AmExCard.b83cf52cca6d809948a33977e1bf79c3.svg";
export { ForwardRef as ReactComponent };